<template>
  <ValidationObserver
    v-slot="{ invalid, passes }"
    tag="div">
    <form @submit.prevent="passes(submit)">
      <div class="container">
        <div class="top">
          <h1 class="title">企業用入力フォーム</h1>
          <p>事前にご案内の「出展社マニュアル」の内容をご確認の上、<br>
          下記フォームの入力にお進みください。<br>
          枠内の情報はイベントサイトにて公開されます。</p>
        </div>
        <div class="topnote">
          <p>※がついているものは必須項目になります。<br>
          必ずご記入ください。</p>
        </div>
        <table>
          <tr>
            <th>会社名※</th>
            <td class="content">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input class="answer" type="text" v-model="company0915.company_name"><br>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <th>担当者名※</th>
            <td class="content">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input class="answer" type="text" v-model="company0915.name"><br>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <th>担当者アドレス※</th>
            <td class="content">
              <ValidationProvider rules="email|required" v-slot="{ errors }">
                <input class="answer" type="text" v-model="company0915.email"><br>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
        </table>
        <table>
          <div class="imagePosted">
            <h2>下記に記載した内容はHPに記載されます</h2>
            <a href="/sendaiCom.png">入力内容の記載イメージ</a>
          </div>
          <div class="question">
            <tr>
              <th>出展内容タイトル（20文字以内）※</th>
              <p class="comment">※会場・オンライン共にタイトルに表示されます。</p>
              <td class="content">
                <ValidationProvider rules="max:20|required" v-slot="{ errors }">
                  <input class="answer" type="text" v-model="company0915.eventname"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>イメージ画像※</th>
              <p class="comment">※600×300のサイズ推奨<br>
              ※jpeg.pngのみ有効です。</p>
              <td class="content">
                <ValidationProvider rules="size:700" v-slot="{ validate,errors }" ref="image">
                  <img class="inputimg" :src="company0915.image">
                  <input class="image" type="file" name="image" @change="upload"><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>イベント会場ブース内容（500文字以内）</th>
                <p class="comment">※当日のブース内容・キャンペーン情報などをご記入ください。</p>
                <td class="content">
                  <ValidationProvider rules="max:500" v-slot="{ errors }">
                    <textarea class="txt" v-model="company0915.offlineDetail" type="text" name="eventVenue"/><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
              </td>
            </tr>
            <tr>
              <th>オンライン配信内容（500文字以内）※</th>
              <p class="comment">※配信内容・視聴者プレゼントやキーワード情報などをご記入ください。</p>
              <td class="content">
                <ValidationProvider rules="max:500|required" v-slot="{ errors }">
                  <textarea class="txt" v-model="company0915.onlineDetail" type="text" name="onlineDetail"/><br>
                  <span class="error">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <div class="box">
              <tr>
                <th>出展社名※</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="answer" type="text" v-model="company0915.exhibitorName"><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th>出展社URL（企業HPなど）※</th>
                <td class="content">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input class="answer" type="text" v-model="company0915.exhibitorUrl"><br>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </td>
              </tr>
            </div>
            <div class="note">
              <p>※配信時間は複数選択してください。<br>
              ※事前に配信URLでのテストを必ずおこなってください。<br><br>
              送信ボタンが押せない場合は以下の原因が考えられます。<br>
              ・必須項目が未入力<br>
              ・入力条件を満たしていない<br>
              再度ご確認のほどよろしくお願いします。<br>
              </p>
            </div>
          </div>
        </table>
        <div class="btn-wrapper btn-next">
          <button
          type="submit"
          class="btn"
          :disabled="invalid || processing"
          :class="{ 'btn-processing': processing }"
          >送信</button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
export default {
  props: {
    company0915: {
      type: Object,
      required: true
    },
    processing: Boolean
  },
  data () {
    return {
      fileName: ''
    }
  },
  methods: {
    submit () {
      this.$emit('submit-form', this.company0915)
    },
    async upload (event) {
      const { valid } = await this.$refs.image.validate(event)
      if (valid) {
        const files = event.target.files || event.dataTransfer.files
        const file = files[0]
        this.fileName = file.name
        const img = await this.getBase64(file)
        this.company0915.image = img
      } else {
        console.log(valid)
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    }
  }
}
</script>
<style lang="sass" scoped>
.container
  width: 100%
  margin: 0 auto
  color: #707070
.top
  width: 100%
  text-align: center
.title
  padding: 40px
  font-size: 30px
.topnote
  font-size: 15px
  text-align: center
  color: red
  font-weight: bold
  padding-top: 30px
.error
  color: red
  margin: 0 30px
.radio
  margin: 10px
table
  margin: 0 auto
table th
  display:flex
  position: relative
  text-align: left
  border-bottom: none
  margin: 20px 30px
  padding: 10px
  border-left: thick solid #3FBD92
  display : block
table td
  text-align: left
  display : block
.imagePosted
  text-align: center
  width: 100%
.imagePosted h2
  color: red
  font-weight: bold
  font-size: 15px
  padding-top: 30px
  padding-bottom: 10px
.imagePosted a
  color: red
  text-decoration: underline
.inputimg
  max-width: 300px
.question
  margin-top: 25px
  background-color: #FFDDE8
.content
  border-bottom: none
  display: block
.contentradio
  border-bottom: none
  display: block
  width: 310px
  margin: 0 30px
.answer
  height: 30px
  width: 310px
  margin-left:  30px
  margin-bottom: 10px
  font-size: 15px
.image
  width: 310px
  margin-left:  30px
  margin-bottom: 10px
.day
  font-weight: bold
  margin-top: 10px
  width: 310px
  margin-left: 30px
.checkboxTime
  width: 310px
  margin: 0 30px
.txt
  height: 180px
  width: 310px
  margin: 0 30px
.comment
  margin-left: 30px
  margin-bottom: 20px
  color: black
.btn-wrapper
  padding: 20px
  text-align: center
.checkbox
  margin: 10px
.note
  color: red
  font-weight: bold
  padding: 20px
  line-height: 25px
.box
  padding-top: 40px
.btn
  font-size: 18px
  font-weight: bold
  padding: 0
  background-color: #3FBD92
  color: #fff
  border-style: none
  border-radius: 8px
  width: 100%
  margin: 0 auto
  height: 50px
.thanks
  background-color: #FFDDE8
  text-align: center
  font-size: 30px
img
  margin: 20px 30px
</style>
